import React, { ReactNode } from 'react';

export interface FilterBarProps {
  /** A StatusSegments, at the left. */
  segments?: ReactNode;
  /** FilterTriggers. */
  children?: ReactNode;
  showClear?: boolean;
  onClear?: () => void;
}

/**
 * The 40px row under the command bar: status segments, a hairline divider,
 * then the filter pills with Clear last. Only the pills group wraps, so on a
 * narrow desktop they drop as a block under the segments.
 */
const FilterBar: React.FC<FilterBarProps> = ({ segments, children, showClear = false, onClear }) => {
  const hasItems = React.Children.count(children) > 0 || showClear;
  return (
    <div className="list-filter-bar">
      {segments && <div className="list-filter-bar__segments">{segments}</div>}
      {segments && hasItems && <span className="list-filter-bar__divider" aria-hidden="true" />}
      {hasItems && (
        <div className="list-filter-bar__items">
          {children}
          {showClear && onClear && (
            <button type="button" className="list-filter-bar__clear" onClick={onClear}>
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterBar;
